/**
 * SSR/undefined-guarded wrapper over the New Relic browser agent's PageAction API,
 * plus a helper that strips empty attributes before emitting. Mirrors the Orders &
 * Purchases repo's Phase 2 instrumentation wrapper.
 *
 * `window.newrelic` is typed in src/global.d.ts; the agent is initialized via
 * NewRelicBridge in src/client.jsx. Both calls no-op when the agent is absent
 * (SSR, or agent not yet loaded), so instrumentation is always safe to call.
 */
export const newrelic = {
  addPageAction: (name: string, value: string | object): void => {
    if (
      typeof window !== 'undefined' &&
      typeof window.newrelic?.addPageAction === 'function'
    ) {
      window.newrelic.addPageAction(name, value);
    }
  },
};

/**
 * Emits a PageAction after dropping any `undefined`/`null` attributes, so events
 * stay clean and don't carry empty keys. Shared by the returns instrumentation helpers.
 */
export const addCleanPageAction = (name: string, attrs: object): void => {
  const clean: Record<string, unknown> = {};
  Object.entries(attrs).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      clean[key] = value;
    }
  });
  newrelic.addPageAction(name, clean);
};
